import _ from "lodash"
import { ICDNode } from "./types/ICDNode"

export const extractKeys = (arr: ICDNode[]) => {
    const _key = (i: ICDNode): string[] => {
        const result = [i.code]
        if (!_.isNil(i.children)) {
            const x = i
                .children
                .flatMap(j => _key(j))
            return result.concat(x)
        }
        return result
    }

    return arr
        .flatMap(i => _key(i))
}